import React, { useEffect, useState } from 'react';
import { Tab, TabbedShowLayout, withDataProvider } from 'react-admin';
import { withStyles } from '@material-ui/core';
import TabbedLayoutStyles from '../../../components/TabbedLayoutStyles';
import EditPageTitle from '../../../components/EditPageTitle';
import { ConsentItemsList, GeneralSettings, Installation } from './tabs';

const MobileConsentSolutionsEdit = ({ dataProvider, classes, history, ...rest }) => {
  const [solution, setSolution] = useState({ name: '' });

  const loadSolution = () => {
    dataProvider.getOne('/universal_consent_solutions', { id: rest.id }).then(({ data }) => {
      setSolution(data);
    });
  };
  useEffect(() => {
    loadSolution();
  }, []);
  return (
    <div className={classes.container}>
      <EditPageTitle onBack={() => history.push('/universal_consent_solutions')} title={`Mobile Consent Solution ${solution.name}`}/>
      <TabbedShowLayout>
        <Tab label="consent items">
          <ConsentItemsList {...rest}/>
        </Tab>
        <Tab label="installation">
          <Installation {...rest} solution={solution}/>
        </Tab>
        <Tab label="general settings" path="general_settings">
          <GeneralSettings {...rest} onUpdateSuccess={loadSolution}/>
        </Tab>
      </TabbedShowLayout>
    </div>
  );
};

export default withStyles(TabbedLayoutStyles)(withDataProvider(MobileConsentSolutionsEdit));
